module.exports = __webpack_public_path__ + "static/media/NAGAD.abef0385.png";